import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { FaInfoCircle } from 'react-icons/fa'
import {
  Badge,
  Btn,
  BtnIcon,
  CustomDataTableHeader,
  CustomDropdown,
  CustomInputTextArea,
  CustomModal,
  CustomPanel,
  DateTime,
  InputText,
  Loading,
  PageHeader,
  Periodo,
  SelectEmpresas,
  ThreeDots,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as OrdemColetaHttp from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import {
  apagarOrdemColeta,
  coletarOrdemColeta,
  finalizarOrdemColeta,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import * as colors from '../../../../assets/js/colors'
import { getCentraisOperacoes } from '../../../../services/localstorage/localstorage.service'
import { sortBy } from '../../../../services/util/array.service'
import { selectOcorrencia } from '../../../../store/actions/ordem-coleta.actions'
import { useOrdensColetaContext } from '../../../../contexts/OrdemColetaContext'

function OrdensColeta({ history, dispatch, selectedTp }) {
  // Vars
  const selectedOrdemInit = {
    descricao: '',
    company_id: '',
    local_descarga_id: '',
    status: 'Aberto',
    observacoes: '',
  }
  // Hooks

  const context = useOrdensColetaContext()
  const [isLoading, setIsLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [showJustificativaCorrecao, setShowJustificativaCorrecao] = useState(false)
  const [ordensColeta, setOrdensColeta] = useState([])
  const [locaisDescarga, setLocaisDescarga] = useState([])
  const [selectedOrdem, setSelectedOrdem] = useState(selectedOrdemInit)
  const [periodo, setPeriodo] = useState(context.ordensColetaContext.selectedPeriodo)
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    fetchOrdensColeta(periodo.dataInicial, periodo.dataFinal)
  }, [selectedTp])

  // Events
  const onBtnNovoClick = () => {
    if (selectedTp === 0) {
      dispatch(
        showMessageBox(null, 'Selecione o Operador Logístico na Barra de Navegação Superior'),
      )
    } else {
      setSelectedOrdem(selectedOrdemInit)
      setShowModal(true)
    }
  }

  const onModalClose = () => {
    setShowModal(false)
  }

  const onModalSuccess = ordem => {
    let ordens
    const index = ordensColeta.findIndex(o => o.id === ordem.id)
    if (index !== -1) {
      ordens = [...ordensColeta]
      ordens[index] = ordem
    } else {
      ordens = [...ordensColeta, ordem]
    }
    setOrdensColeta(sortBy(ordens, 'id', false))
    setShowModal(false)
  }

  const onModalError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const onPesquisar = async (periodoInicial, periodoFinal) => {
    if (!selectedTp) dispatch(showMessageBox(null, 'Selecione um TP'))
    else {
      setIsLoading(true)
      setPeriodo({ dataInicial: periodoInicial, dataFinal: periodoFinal })
      context.setOrdensColetaContext(prevContext => ({
        ...prevContext,
        selectedPeriodo: { dataInicial: periodoInicial, dataFinal: periodoFinal },
      }))
      await fetchOrdensColeta(periodoInicial, periodoFinal)
    }
  }

  const onGerarConferencia = async ordem_coleta_id => {
    setIsLoading(true)
    try {
      const result = await OrdemColetaHttp.createConferenciaOrdemColeta(ordem_coleta_id)
      const index = ordensColeta.findIndex(o => o.id === result.id)
      if (index !== -1) {
        const nOrdens = [...ordensColeta]
        nOrdens[index].status = 'Em Conferencia'
        setOrdensColeta(nOrdens)
      }
      dispatch(showMessageBox('Conferencia criada com sucesso', null))
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoading(false)
    }
  }

  const onMenuItemClicked = (menuItem, ordem, pInicial, pFinal) => {
    switch (menuItem) {
      case '1. Editar':
        setSelectedOrdem(ordem)
        setShowModal(true)
        break
      case '2. Apagar':
        onApagarOrdemClick(ordem.id)
        break
      case '3. Ocorrências Pendentes':
        dispatch(selectOcorrencia(0, ''))
        history.push('/main/ordemcoleta/ocorrencias-pendentes', {
          ordem,
        })
        break
      case '4. Ocorrências Associadas':
        history.push('/main/ordemcoleta/ocorrencias-associadas', { ordem })
        break
      case '5. Visualizar':
        history.push('/main/ordemcoleta/visualizar', { ordem })
        break
      case '6. Finalizar':
        onFinalizarOrdemClick(ordem.id)
        break
      case '7. Coletar':
        onColetarOrdemClick(ordem, pInicial, pFinal)
        break
      case '8. Gerar Conferencia':
        onGerarConferencia(ordem.id)
        break
      case '9. Ver Conferencia':
        history.push('/main/ordemcoleta/conferencia-ordem-coleta', { ordem })
        break
      default:
        dispatch(showMessageBox(null, 'Menu Item - ação não cadastrada'))
    }
  }

  const onFinalizarOrdemClick = async ordem_id => {
    try {
      await finalizarOrdemColeta(ordem_id)
      const index = ordensColeta.findIndex(o => o.id === ordem_id)
      if (index !== -1) {
        const nOrdens = [...ordensColeta]
        nOrdens[index].status = 'Finalizado'
        setOrdensColeta(nOrdens)
        dispatch(showMessageBox('Operação Realizada com Sucesso', null))
      }
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onColetarOrdemClick = async (ordem, pInicial, pFinal) => {
    try {
      await coletarOrdemColeta(ordem.id)
      await fetchOrdensColeta(pInicial, pFinal)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onApagarOrdemClick = async ordem_id => {
    try {
      await apagarOrdemColeta(ordem_id)
      const nOrdens = ordensColeta.filter(o => o.id !== ordem_id)
      setOrdensColeta(nOrdens)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onJustificativaCorrecaoClick = ordem => {
    setSelectedOrdem(ordem)
    setShowJustificativaCorrecao(true)
  }

  const onJustificativaModalClose = () => {
    setShowJustificativaCorrecao(false)
  }

  // Helpers
  const fetchOrdensColeta = async (pInicial, pFinal) => {
    try {
      const operationcenter_ids = getCentraisOperacoes().map(co => co.id)
      const { ordens, locais } = await OrdemColetaHttp.getOrdensColeta(
        selectedTp,
        operationcenter_ids,
        pInicial,
        pFinal,
      )
      setOrdensColeta(ordens)
      setLocaisDescarga(locais)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return (
    <React.Fragment>
      <PageHeader>5.1 - Ordens de Coleta</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onBtnNovoClick} onVoltar={() => history.goBack()}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <React.Fragment>
              <div className="p-grid">
                <div className="p-col-12">
                  <Periodo
                    periodoInicial={periodo.dataInicial}
                    periodoFinal={periodo.dataFinal}
                    onPesquisar={(pInicial, pFinal) => onPesquisar(pInicial, pFinal)}
                  />
                </div>
              </div>
              <div style={{ marginTop: 20 }}>
                <OrdemDataTable
                  ordens={ordensColeta}
                  onMenuItemClicked={(item, ordem) =>
                    onMenuItemClicked(item, ordem, periodo.dataInicial, periodo.dataFinal)
                  }
                  onJustificativaCorrecaoClick={onJustificativaCorrecaoClick}
                  globalFilter={globalFilter}
                  onGlobalFilterChange={value => setGlobalFilter(value)}
                />
              </div>
            </React.Fragment>
          )}
        </CustomPanel>
        {showModal ? (
          <OrdemModal
            selectedOrdem={selectedOrdem}
            locaisDescarga={locaisDescarga}
            onModalClose={onModalClose}
            onModalError={onModalError}
            onModalSuccess={onModalSuccess}
            selectedTp={selectedTp}
          />
        ) : null}
        <JustificativaModal
          isVisible={showJustificativaCorrecao}
          ordem={selectedOrdem}
          onClose={onJustificativaModalClose}
        />
      </div>
    </React.Fragment>
  )
}

function OrdemModal({
  selectedOrdem,
  locaisDescarga,
  selectedTp,
  onModalClose,
  onModalSuccess,
  onModalError,
}) {
  // Hooks
  const [ordem, setOrdem] = useState(selectedOrdem)
  const [isLoading, setIsLoading] = useState(false)

  // Events
  const onModalSalvar = async () => {
    try {
      setIsLoading(true)
      if (ordem.descricao.trim().length === 0) {
        showError('Descrição da Ordem de Coleta incorreta')
      } else if (!ordem.local_descarga_id) {
        showError('Selecione o Local de Descarga')
      } else if (!ordem.company_id) {
        showError('Selecione a Empresa')
      } else {
        // {id, tp_id, descricao, justificativa_correcao, status, company_id,local_descarga_id}
        let savedOrdem
        if (ordem.id) {
          savedOrdem = await OrdemColetaHttp.atualizarOrdemColeta({
            id: ordem.id,
            tp_id: selectedTp,
            descricao: ordem.descricao,
            justificativa_correcao: null,
            status: ordem.status,
            company_id: ordem.company_id,
            local_descarga_id: ordem.local_descarga_id,
            observacoes: ordem.observacoes,
          })
        } else {
          savedOrdem = await OrdemColetaHttp.salvarOrdemColeta({
            tp_id: selectedTp,
            descricao: ordem.descricao,
            company_id: ordem.company_id,
            local_descarga_id: ordem.local_descarga_id,
            observacoes: ordem.observacoes,
          })
        }
        onModalSuccess(savedOrdem)
      }
    } catch (e) {
      showError(errorHandler(e))
    }
  }

  // Helpers
  const showError = errorMessage => {
    onModalError(errorMessage)
    setIsLoading(false)
  }

  const parseLocais = locais => {
    return locais.map(local => ({ label: local.name, value: local.id }))
  }

  // Render
  return (
    <CustomModal
      header={ordem.descricao === '' ? 'Nova Ordem de Coleta' : 'Editar Ordem de Coleta'}
      isVisible={true}
      onClose={onModalClose}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            disabled={ordem.status !== 'Aberto' && ordem.status !== 'Correcao'}
            label="Descrição :"
            marginTop={10}
            value={ordem.descricao}
            onChange={descricao => setOrdem({ ...ordem, descricao })}
          />
        </div>
        <div className="p-col-6">
          <SelectEmpresas
            disabled={ordem.status !== 'Aberto' && ordem.status !== 'Correcao'}
            companyId={ordem.company_id}
            onChange={empresa => setOrdem({ ...ordem, company_id: empresa.id })}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            disabled={ordem.status !== 'Aberto' && ordem.status !== 'Correcao'}
            label="Local de Descarga"
            value={ordem.local_descarga_id ? ordem.local_descarga_id : ''}
            options={parseLocais(locaisDescarga)}
            onChange={local_id => setOrdem({ ...ordem, local_descarga_id: local_id })}
          />
        </div>
        <div className="p-col-12">
          <CustomInputTextArea
            disabled={ordem.status !== 'Aberto' && ordem.status !== 'Correcao'}
            label="Observações"
            marginTop={0}
            value={ordem && ordem.observacoes ? ordem.observacoes : ''}
            onChange={observacoes => setOrdem({ ...ordem, observacoes })}
          />
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onModalSalvar}>
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}

function OrdemDataTable({
  ordens,
  onMenuItemClicked,
  onJustificativaCorrecaoClick,
  globalFilter,
  onGlobalFilterChange,
}) {
  // Render
  return (
    <DataTable
      value={ordens}
      emptyMessage="Não existe Ordem de Coleta cadastrada neste Período"
      globalFilter={globalFilter}
      header={<CustomDataTableHeader onChange={onGlobalFilterChange} />}
      rows={10}
      paginator={true}
    >
      <Column field="id" header="Cód." style={tableCellCentered(50)} />
      <Column field="descricao" header="Ordem de Coleta" />
      <Column field="local_descarga" header="Local de Descarga" style={tableCellCentered(200)} />
      <Column field="company" header="Empresa" style={tableCellCentered(200)} />
      <Column
        field="created_at"
        header="Criada em"
        style={tableCellCentered()}
        body={ordem => <DateTime>{ordem.created_at}</DateTime>}
      />
      <Column
        field="status"
        header="Status"
        style={tableCellCentered(150)}
        body={ordem => {
          switch (ordem.status) {
            case 'Aberto':
              return <Badge color={colors.laranja}>Aberto</Badge>
            case 'Correcao':
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'inline-block', marginLeft: 30 }}>
                    <Badge color={colors.vinho}>Correção</Badge>
                  </div>
                  <BtnIcon onClick={() => onJustificativaCorrecaoClick(ordem)}>
                    <FaInfoCircle color={colors.vinho} size={18} />
                  </BtnIcon>
                </div>
              )
            case 'Finalizado':
              return <Badge color={colors.azul}>Finalizado</Badge>
            case 'Aprovado':
              return <Badge color={colors.azul_escuro}>Aprovado</Badge>
            case 'Coletado':
              return <Badge color={colors.verde}>Coletado</Badge>
            case 'Em Conferencia':
              return <Badge color={colors.azul_claro}>Em Conferencia</Badge>
            case 'Conferido':
              return <Badge color={colors.pink}>Conferido</Badge>
            default:
              return null
          }
        }}
      />
      <Column
        header="Menu"
        style={tableCellCentered(70)}
        body={ordem => (
          <ThreeDots
            items={[
              '1. Editar',
              '2. Apagar',
              '3. Ocorrências Pendentes',
              '4. Ocorrências Associadas',
              '5. Visualizar',
              '6. Finalizar',
              '7. Coletar',
              '8. Gerar Conferencia',
              '9. Ver Conferencia',
            ]}
            onClick={item => onMenuItemClicked(item, ordem)}
          />
        )}
        bodyStyle={tableCellCentered()}
      />
    </DataTable>
  )
}

function JustificativaModal({ ordem, isVisible, onClose }) {
  // Vars
  const { justificativa_correcao } = ordem
  // Hooks
  const [justificativa, setJustificativa] = useState(justificativa_correcao)

  useEffect(() => {
    setJustificativa(justificativa_correcao)
  }, [justificativa_correcao])

  // Render
  return (
    <CustomModal isVisible={isVisible} onClose={onClose} header="Motivo da Correção">
      <CustomInputTextArea marginTop={0} value={justificativa} showLabel={false} />
    </CustomModal>
  )
}

const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(OrdensColeta))
